import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://drfjzweglbzmfyawgqrh.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRyZmp6d2VnbGJ6bWZ5YXdncXJoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcyOTc3MjMsImV4cCI6MjA3Mjg3MzcyM30.bqpEV8mZqq0HEm7aQPGYEESqKNwCLrxuNwv8vQUrgnY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'x-my-custom-header': 'free-music-app'
    }
  }
})

// 数据库表名常量
export const TABLES = {
  USERS: 'users',
  TRACKS: 'tracks',
  USER_FAVORITES: 'user_favorites',
  RECOMMENDATIONS: 'recommendations',
  MOOD_SESSIONS: 'mood_sessions'
}

export default supabase
